import React from 'react';
import { Breadcrumb } from '../presentation/Breadcrumb';
import { CategoryBanner } from '../presentation/CategoryBanner';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';
import { ThankYouPage } from '../presentation/ThankYou';


export const ThankYou = () => {
  return (
    <>
      <Header />
      <CategoryBanner />
      <Breadcrumb />
      <ThankYouPage />
      <Footer />
    </>
  )
}